import OpportunitiesTable from './OpportunitiesTable';

export * from './OpportunitiesTable';
export default OpportunitiesTable;
